// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";



const firebaseConfig = {
  apiKey: "AIzaSyDbeJ3Wh1xMc_bAxn-_-o8qFQIsLDixJuA",
  authDomain: "kyro-studios.firebaseapp.com",
  projectId: "kyro-studios",
  storageBucket: "kyro-studios.firebasestorage.app",
  messagingSenderId: "85485286567",
  appId: "1:85485286567:web:f8e6aa5e5a074527e51782",
  measurementId: "G-QP9QZY3K0L"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

export { app, analytics, db };
